import React,{useContext,useEffect} from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { withRouter } from "react-router-dom";
import { formatPrice } from "../helpers/format";
import NumberFormat from "react-number-format";
import { useWindowSize } from "react-use";
import Loader from "../components/Loader";
import TradathonContext from "../context/tradathon/TradathonContext";
const PublicContestModal = ({ close,formData }) => {
    const {winnings,getWinningsDistribution } = useContext(TradathonContext)
  const { width } = useWindowSize();

useEffect(() => {
    getWinningsDistribution(formData)
    //eslint-disable-next-line
},[])
  return <div className="Register">
      <div
        className="Login__container"
        style={{
          width: width > 900 ? "60%" : "100%",
          padding: width > 900 ? "20px" : 0,
          bottom: "10%",
          overflow: "auto",
        }}
      >
        <div style={{ textAlign: "right" }} onClick={() => close()}>
          <IoIosCloseCircleOutline size={40} style={{ cursor: "pointer" }} />
        </div>
        <h4 style={{ margin: "20px 5px" }}>
          Amount would be distributed as follows:
        </h4>
        {!winnings || !winnings.length > 0 ? (
          <Loader />
        ) : (
          <center>
            <table
              className="Home__MainTable"
              style={{
                marginTop: "10px",
                background: "#EFF2F5",
                width: width > 1000 ? "50%" : "90%",
              }}
            >
              <thead>
                <tr>
                  <th>
                    <div
                      className="Home__MainTable-th"
                      style={{ justifyContent: "center" }}
                    >
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Rank </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      className="Home__MainTable-th"
                      style={{ justifyContent: "center" }}
                    >
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Winnings</div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {winnings && winnings.length > 0 ? (
                  winnings.map((c, index) => (
                    <>
                      <tr key={index} className="Home__MainTable__link">
                        <td style={{ textAlign: "center" }}>{c.range}</td>

                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{ justifyContent: "center" }}
                          >
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                            >
                              <NumberFormat
                                value={formatPrice(c.amt)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix="₹"
                              />
                            </p>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </center>
        )}

        </div>
   

        {/* )} */}
    
    </div>
  
};

export default withRouter(PublicContestModal);
